import maAccordion from '@/components/accordion'
import maConfrimBtn from '@/components/button-blue'
import maInputBtn from '@/components/input/modules/btn'
import maInputRadio from '@/components/input/modules/radio'
import maInputText from '@/components/input/modules/text'
import maInputTextarea from '@/components/input/modules/textarea'
import maNavbarStepper from '@/components/navbarStepper'
import { apiGetSinister } from '@/modules/Claim/services/sinister'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { apiPostTimeStamp } from '@/modules/User/services/timeStamp'
import {
  WARRANTY_GET_SINISTER,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_ADDRESS,
  WARRANTY_UPDATE_COORDINATES,
  WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
  WARRANTY_UPDATE_OBSERVATIONS,
  WARRANTY_UPDATE_PROPERTY_TYPE,
  WARRANTY_UPDATE_PROPS,
  WARRANTY_UPDATE_RESIDENT_TYPE,
  WARRANTY_UPDATE_ZIP_CODE
} from '@/store/types'
import setTimeStamp from '@/utils/timeStamp.js'
import { mapActions, mapMutations, mapState } from 'vuex'
import { capitalize } from '@/utils/capitalize'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'claimDetails',
  mixins: [flowMixin],

  data: function () {
    return {
      place: {},
      panorama: null,
      service: null,
      errorPostCodeNotFound: false,
      errorSinisterNotFOund: false,
      errorMsgPostCodeNotFound: 'noError',
      errorAddress: false,
      errorPropery: false,
      errorAge: false,
      errorResident: false,
      errorMsgGeneral: 'Error de saisse',
      keyBtns: 0,
      countryCode: null,
      timeStampStart: null,
      timeStampFinish: null,
      propertyTypeOptions: [
        {
          key: 'appartement',
          literal: 'claim.details.propertyType.options.appartment'
        },
        {
          key: 'maison',
          literal: 'claim.details.propertyType.options.maison'
        },
        {
          key: 'local_commercial',
          literal: 'claim.details.propertyType.options.local_commercial'
        }
      ],
      residentTypeOptions: [
        {
          key: 'propietarie',
          literal: 'claim.details.residentType.options.propietarie'
        },
        {
          key: 'locataire',
          literal: 'claim.details.residentType.options.locataire'
        },
        {
          key: 'propietarie_non_occupant',
          literal: 'claim.details.residentType.options.propietarie_non_occupant'
        }
      ],
      moreThanTwoYearsOptions: [
        {
          key: true,
          literal: 'claim.details.moreThanTwoYears.options.more'
        },
        {
          key: false,
          literal: 'claim.details.moreThanTwoYears.options.less'
        }
      ]
    }
  },

  components: {
    maInputText,
    maInputTextarea,
    maInputRadio,
    maAccordion,
    maInputBtn,
    maConfrimBtn,
    maNavbarStepper
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyAddress: 'address',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyObservations: 'observations',
      stateWarrantySinisterSummary: 'sinisterSummary'
    }),

    stateComWarrantyAddress: {
      get() {
        return this.stateWarrantyAddress
      },
      set(v) {
        this.mutWarrantySetAddress(v)
      }
    },
    stateComWarrantyZipCode: {
      get() {
        return this.stateWarrantyZipCode
      },
      set(v) {
        this.mutWarrantySetZipCode(v)
      }
    },
    stateComWarrantyPropertyType: {
      get() {
        return this.stateWarrantyPropertyType
      },
      set(v) {
        this.mutWarrantySetPropertyType(v)
      }
    },
    stateComWarrantyResidentType: {
      get() {
        return this.stateWarrantyResidentType
      },
      set(v) {
        this.mutWarrantySetResidentType(v)
      }
    },
    stateComWarrantyObservations: {
      get() {
        return this.stateWarrantyObservations
      },
      set(v) {
        this.mutWarrantySetObservations(v)
      }
    },
    stateComWarrantyMoreThanTwoYears: {
      get() {
        return this.stateWarrantyMoreThanTwoYears
      },
      set(v) {
        this.mutWarrantySetAge(v)
      }
    },
    stateComWarrantyCoordinates: {
      get() {
        return this.stateWarrantyCoordinates
      },
      set(v) {
        let coordinates = { lat: 0, lng: 0 }

        if (v && v.geometry && v.geometry.location) {
          coordinates.lat =
            parseFloat(v.geometry.location.lat().toFixed(10)) || 0
          coordinates.lng =
            parseFloat(v.geometry.location.lng().toFixed(10)) || 0
        } else {
          coordinates = null
        }
        this.mutWarrantySetCoordinates(coordinates)
      }
    },

    showStreetView: function () {
      return (
        this.stateComWarrantyCoordinates &&
        this.stateComWarrantyCoordinates.lat &&
        this.stateComWarrantyCoordinates.lng
      )
    },

    messageErrPostCode() {
      if (this.errorPostCodeNotFound) {
        return this.$t(`${this.errorMsgPostCodeNotFound}`)
      } else if (!this.stateWarrantyZipCode) {
        return this.$t('claim.details.errorMsgInputTxt')
      } else {
        return this.$t(`${this.errorMsgPostCodeNotFound}`)
      }
    },

    /**
     * @name isConfirmDisabled
     * @description
     *   Determines whether the "Continue" button should be disabled.
     *   Returns true if any of the following conditions is met:
     *     - stateWarrantyAddress is empty or consists of only whitespace
     *     - stateWarrantyPropertyType is '' or null
     *     - stateWarrantyResidentType is '' or null
     *     - stateWarrantyMoreThanTwoYears is null (either true or false is acceptable)
     * @returns {boolean}
     *   True when the button must remain disabled; false when it can be enabled.
     */
    isConfirmDisabled () {
      const hasAddress = this.stateWarrantyAddress && this.stateWarrantyAddress.trim() !== ''
      const hasPropertyType = this.stateWarrantyPropertyType !== '' && this.stateWarrantyPropertyType != null
      const hasResidentType = this.stateWarrantyResidentType !== '' && this.stateWarrantyResidentType != null
      const hasYearsFlag = this.stateWarrantyMoreThanTwoYears !== null

      return !(hasAddress && hasPropertyType && hasResidentType && hasYearsFlag)
    }

  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantySetAddress: WARRANTY_UPDATE_ADDRESS,
      mutWarrantySetPropertyType: WARRANTY_UPDATE_PROPERTY_TYPE,
      mutWarrantySetResidentType: WARRANTY_UPDATE_RESIDENT_TYPE,
      mutWarrantySetAge: WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
      mutWarrantySetZipCode: WARRANTY_UPDATE_ZIP_CODE,
      mutWarrantySetCoordinates: WARRANTY_UPDATE_COORDINATES,
      mutWarrantySetObservations: WARRANTY_UPDATE_OBSERVATIONS
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyUpdateProps: WARRANTY_UPDATE_PROPS,
      actWarrantyGetSinister: WARRANTY_GET_SINISTER,
      actWarrantyGetSinisterSummary: WARRANTY_GET_SINISTER_SUMMARY
    }),
    initAutocomplete: function () {
      const inputDom = document.getElementsByName('propsAddress')[0] || null
      if (inputDom) {
        const options = {
          types: ['geocode'],
          fields: ['address_components', 'formatted_address', 'geometry']
        }
        if (this.countryCode && this.countryCode.length > 0) {
          options.componentRestrictions = { country: [this.countryCode] }
        }
        // eslint-disable-next-line
        const autocompleteObject = new google.maps.places.Autocomplete(
          inputDom,
          options
        )
        autocompleteObject.addListener(
          'place_changed',
          function () {
            const place = autocompleteObject.getPlace()
            this.handleSelectPlace(place)
            this.mutWarrantySetAddress(place.formatted_address)
          }.bind(this)
        )
      }
    },

    handleSelectPlace: function (place) {
      this.place = place
      this.$store.commit(
        `${WARRANTY_MODULE_NAME}/WARRANTY_UPDATE_ZIP_CODE`,
        this.getPlacePostalCode(place)
      )
      if (place) {
        this.stateComWarrantyCoordinates = place
      }
    },

    getPlacePostalCode: function (place) {
      let zipCode = ''
      let originalZipCode = ''
      if (this.stateWarrantyZipCode && this.stateWarrantyZipCode.length > 0) {
        originalZipCode = this.stateWarrantyZipCode
      }
      if (place && 'address_components' in place) {
        const addressComponents = place.address_components
        const zipCodeAddressComponent = addressComponents.find(
          (addressComponent) => {
            if ('types' in addressComponent) {
              return addressComponent.types.includes('postal_code')
            }
            return false
          }
        )

        if (zipCodeAddressComponent && 'long_name' in zipCodeAddressComponent) {
          zipCode = zipCodeAddressComponent.long_name || ''
        }
      }
      if (!zipCode || zipCode.length < 1) {
        zipCode = originalZipCode
      }
      return zipCode
    },

    /**
     * Init map and street view services.
     */
    initMap: function () {
      // eslint-disable-next-lineha
      // eslint-disable-next-line no-undef
      this.service = new google.maps.StreetViewService()
      // eslint-disable-next-line
      this.panorama = new google.maps.StreetViewPanorama(
        document.getElementById('warrantyProps_street-view'),
        { zoom: 1 }
      )
    },
    setWatchers: function () {
      this.$watch('stateWarrantyAddress', function (value) {
        if (value) this.errorAddress = false
      })
    },

    /**
     * Set POV of StreetView using spherical tools of google maps
     * geometry library.
     */
    setPlacePov: function () {
      let pov = {
        heading: 0,
        pitch: 0
      }

      this.service.getPanoramaByLocation(
        this.panorama.getPosition(),
        50,
        function (panoData) {
          if (panoData != null) {
            // pov coordinates
            const manLatLng = panoData.location.latLng
            // eslint-disable-next-line
            const targetLatLngObject = new google.maps.LatLng(
              this.stateComWarrantyCoordinates.lat,
              this.stateComWarrantyCoordinates.lng
            )
            // eslint-disable-next-line
            pov.heading = google.maps.geometry.spherical.computeHeading(
              manLatLng,
              targetLatLngObject
            )
            this.panorama.setPov(pov)
          }
        }.bind(this)
      )
    },

    handleConfirmInfo() {
      const moreThanTwoYearsCondition =
        this.stateWarrantyMoreThanTwoYears !== null
      if (
        this.stateWarrantyAddress &&
        this.stateWarrantyZipCode &&
        this.stateWarrantyPropertyType &&
        this.stateWarrantyResidentType &&
        moreThanTwoYearsCondition &&
        this.stateWarrantyCoordinates
      ) {
        this.actWarrantyUpdateProps().then((resp) => {
          if (resp) {
            if (this.isE2EFlow || this.isBillmaBPCEFlow) {
              this.goToNextState()
            } else {
              this.goToNextState(FLOW_TRANSITIONS.ADD_DAMAGES)
            }
          }
        }).catch((error) => {
          const context = {
            component: 'claimDetails',
            method: 'handleConfirmInfo',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error updating warranty props in confirm info: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getSinisterId,
            'handleConfirmInfo'
          )
        })
      } else {
        this.setWatchers()
        if (!this.stateWarrantyAddress) this.errorAddress = true
        if (!this.stateWarrantyPropertyType) this.errorPropery = true
        if (this.stateWarrantyMoreThanTwoYears === '') this.errorAge = true
        if (!this.stateComWarrantyResidentType) this.errorResident = true
        window.scrollTo(0, 0)
      }
    },
    /**
     * Sets the position of the map using the coordinates
     */
    setMap() {
      this.panorama.setPosition(this.stateComWarrantyCoordinates)
      this.panorama.setPov(this.setPlacePov())
      this.timeStampFinish = setTimeStamp.call()
    },

    /**
     * Sends the timestamps by a post to back end
     */
    sendTimeStamp() {
      const timeStampParams = {
        description: 'Searching in google street view',
        sinister_id: this.getSinisterId,
        start: this.timeStampStart,
        end: this.timeStampFinish
      }
      apiPostTimeStamp(timeStampParams).catch((error) => {
        const context = {
          component: 'claimDetails',
          method: 'sendTimeStamp',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error posting timestamp: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'sendTimeStamp'
        )

        const errs = [400, 500, 409, 404]
        const errCode =
          errs.find((errCode) => error.response.status === errCode) || 0
        this.throwNotification(
          this.$t(`notifications.user.error.${errCode}.title`),
          this.$t(`notifications.user.error.${errCode}.body`),
          'KO'
        )
      })
    },
    capitalizedWarrantyPropertyType() {
      return capitalize(this.stateWarrantyPropertyType)
    },
    async handleChangeOption(value, type) {
      switch (type) {
        case 'property':
          this.stateComWarrantyPropertyType = value
          break
        case 'resident':
          this.stateComWarrantyResidentType = value
          break
        case 'moreThanTwoYears':
          this.stateComWarrantyMoreThanTwoYears = value
          break
      }

      this.timeStampStart = setTimeStamp()
      this.setMap()
      this.sendTimeStamp()

      try {
        await this.actWarrantyUpdateProps()
      } catch (error) {
        const context = {
          component: 'claimDetails',
          method: 'handleChangeOption',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error updating warranty props after option change: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'handleChangeOption'
        )
      }
    }
  },

  /**
   * * Get sinister information, initializes map, gets the sinister summary - updates the damages count if there are any, and if so the navbar will show the cart damages
   */
  mounted: async function () {
    const sinisterId = this.getSinisterId

    this.actWarrantyGetSinisterSummary(sinisterId).then(() => {
      this.damagesList = this.stateWarrantySinisterSummary
    })
    await this.actWarrantyGetSinister(this.getSinisterId).then((resp) => {
      if (!resp.isSinisterFound) {
        this.throwNotification(
          this.$t('notifications.loadSinisterKO.title'),
          this.$t('notifications.loadSinisterKO.body'),
          'KO'
        )
      }
    })

    this.countryCode = localStorage.getItem('mavCountryCode')
    this.initMap()
    this.initAutocomplete()
    this.timeStampStart = setTimeStamp()
    this.setMap()
    this.sendTimeStamp()
    this.notifyAppOfChanges(this)
  },

  /**
   * When coordinates change, pov and map position are recalculated.
   * It's also sent to backend,because props info are used for
   * calculate sinister value.
   */
  watch: {
    stateComWarrantyCoordinates: function () {
      if (
        this.panorama &&
        this.stateWarrantyCoordinates &&
        this.stateComWarrantyZipCode
      ) {
        this.timeStampStart = setTimeStamp()
        this.setMap()
        this.sendTimeStamp()
        this.actWarrantyUpdateProps().then((resp) => {
          if (resp && resp.error) {
            apiGetSinister(this.getSinisterId)
              .then((data) => {
                this.mutWarrantySetZipCode(data.zip_code)
                this.mutWarrantySetAddress(data.address)
                this.countryCode = localStorage.getItem('mavCountryCode')

                this.errorPostCodeNotFound = true
                this.throwNotification(
                  this.$t('claim.details.errorMsgGeneral'),
                  this.$t('claim.details.errorMsgGeneral'),
                  'KO'
                )
                setTimeout(() => {
                  this.errorPostCodeNotFound = false
                }, 2000)
              })
              .catch((error) => {
                const context = {
                  component: 'claimDetails',
                  method: 'stateComWarrantyCoordinates.watch.apiGetSinister',
                  route: this.$route.path
                }

                const tags = prepareErrorForSentry(error, context)

                this.sendSentryError(
                  `Error getting sinister in coordinates watch: ${error.message || 'Unknown error'}`,
                  error.response && error.response.status >= 500 ? 'error' : 'warning',
                  tags,
                  this.getSinisterId,
                  'stateComWarrantyCoordinates.watch.apiGetSinister'
                )

                const errs = [400, 500, 409, 404]
                const errCode =
                  errs.find((errCode) => error.response.status === errCode) || 0
                this.throwNotification(
                  this.$t(`notifications.error.${errCode}.title`),
                  this.$t(`notifications.error.${errCode}.title`),
                  'KO'
                )
                window.scrollTo(0, 0)
                this.mutWarrantySetZipCode()
                this.mutWarrantySetAddress()
              })
          }
        })
      }
    }
  }
}
